import * as React from 'react';
import './App.css';

import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import AppProvider from './_context/App';
import { ClassNames } from './_helpers/ClassNames';
import Page from './Components/Page/Page';

class App extends React.Component {
	public render() {
		return (
			<Router>
				<AppProvider>
					<div className={ClassNames('app', '')}>
						<Switch>
							<Route component={Page} />
						</Switch>
					</div>
				</AppProvider>
			</Router>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx